export default __webpack_public_path__ + "static/media/98-03_header_invoice.c4511df5.png";